
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/2020-01-01-how-to-automate-the-backend-stuffs-with-open-source-headless-cms-strapi-and-docker",
      function () {
        return require("private-next-pages/articles/2020-01-01-how-to-automate-the-backend-stuffs-with-open-source-headless-cms-strapi-and-docker.mdx");
      }
    ]);
  